import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { instanceOf } from "prop-types";
import NotFound from "./not-found";
import Default from "./default";
import HttpError from "./http-error";
import { isHttpError, isNotFoundError } from "glesys-controlpanel/utils/errors";

@forbidExtraArgs
export default class RouteError extends Component {
  @arg(instanceOf(Error).isRequired) error;

  get component() {
    switch (true) {
      case isNotFoundError(this.error):
        return NotFound;
      case isHttpError(this.error):
        return HttpError;
      default:
        return Default;
    }
  }

  <template>
    <div data-test-route-error ...attributes>
      {{component this.component error=this.error}}
    </div>
  </template>
}
